import { createAction, props } from "@ngrx/store";
import { Team } from "../../models/team.models";
import { User } from "../../models/user.model";

export const LOAD_TEAMS = '[Teams] Load teams';
export const LOAD_TEAMS_SUCCESS = '[Teams] Load teams success';
export const LOAD_TEAMS_FAIL = '[Teams] Load teams fail';
export const ADD_TEAM = '[Teams] Add team';
export const ADD_TEAM_SUCCESS = '[Teams] Add team success';
export const ADD_TEAM_FAIL = '[Teams] Add team fail';
export const DELETE_TEAM = '[Teams] Delete team';
export const DELETE_TEAM_SUCCESS = '[Teams] Delete team success';
export const DELETE_TEAM_FAIL = '[Teams] Delete team fail';
export const UPDATE_TEAM = '[Teams] Update team';
export const UPDATE_TEAM_SUCCESS = '[Teams] Update team success';
export const UPDATE_TEAM_FAIL = '[Teams] Update team fail';

export const LoadTeamsAction = createAction(
    LOAD_TEAMS,
    props<{ data: User }>()
);

export const LoadTeamsSuccessAction = createAction(
    LOAD_TEAMS_SUCCESS,
    props<{ data: Team[] }>()
);

export const LoadTeamsFailAction = createAction(
    LOAD_TEAMS_FAIL,
    props<{ error: Error }>()
);

export const AddTeamAction = createAction(
    ADD_TEAM,
    props<{ data: Team }>()
);

export const AddTeamSuccessAction = createAction(
    ADD_TEAM_SUCCESS,
    props<{ data: Team[] }>()
);

export const AddTeamFailAction = createAction(
    ADD_TEAM_FAIL,
    props<{ error: Error }>()
);

export const DeleteTeamAction = createAction(
    DELETE_TEAM,
    props<{ data: Team }>()
);

export const DeleteTeamSuccessAction = createAction(
    DELETE_TEAM_SUCCESS,
    props<{ data: Team[] }>()
);

export const DeleteTeamFailAction = createAction(
    DELETE_TEAM_FAIL,
    props<{ error: Error }>()
);

export const UpdateTeamAction = createAction(
    UPDATE_TEAM,
    props<{ data: Team }>()
);

export const UpdateTeamSuccessAction = createAction(
    UPDATE_TEAM_SUCCESS,
    props<{ data: Team[] }>()
);

export const UpdateTeamFailAction = createAction(
    UPDATE_TEAM_FAIL,
    props<{ error: Error }>()
);
